<template>
  <div>
    <navbar :is-spaced="false" />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  layout: 'whitelabel',
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/loanApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  head () {
    const desc = 'Pyydä lainatarjous ilman sitoutumista. Paras laina meidän avulla Maksuton 500 - 60.000€ lainojen kilpailutus. Hae lainaa nyt.'
    const theme = '#364f89'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/lainahelppi/favicon.png' ) }]
    }
  },
  data () {
    return {
      name: 'Lainahelppi',
      domain: 'lainahelppi.fi'
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #364f89;
$wl-body-background: #fff;

$wl-navbar-background: #172638;
$wl-navbar-height: 4.75rem;

$wl-app-background: #dae7f6;
$wl-app-border: 1px solid #b9c5d2;

$wl-slider-handle-border: 2px solid white;

$wl-footer-color: white;
$wl-footer-background: #000d29;

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.lainahelppi {
  @include whitelabel;
}
</style>
